import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';

import type { ConversationActionWithAssistantMetadata } from './action-capabilities';

export const getConversationActionWithAssistantMetadata = (
	action: ConversationAction | undefined,
): ConversationActionWithAssistantMetadata | undefined =>
	action as ConversationActionWithAssistantMetadata | undefined;
